import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { BookingService } from 'src/app/core/services/booking.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth/auth.service';

declare let gtag: (property: string, value: any, configs: any) => {};
@Component({
  selector: 'app-ending-booking',
  templateUrl: './ending-booking.component.html',
  styleUrls: ['./ending-booking.component.scss']
})
export class EndingBookingComponent implements OnInit {

  public date: string = '';
  public plant: string = '';
  public hour: string = '';
  public address: string = '';
  public reference: string = '';
  public codePlant: string = '';
  public codeType: string = '';
  public reservationCode: string = '';
  public vehicle_patent: string = '';
  public check: boolean = false;
  public tarifa: string = '';
  public latitude: string = '';
  public longitude: string = '';
  public zoom: number = 13;
  public typeReser: string;
  public planta: boolean = false;
  public confirmedPayment: boolean = false;
  public isRebooking: boolean = false;

  private token_ws: string = '';
  constructor(private bookingService: BookingService,
    private route: Router,
    private routePath: ActivatedRoute,
    private authService: AuthService) {
    routePath.queryParamMap.subscribe((query: any) => {
      if (query.params.rebook)
        this.isRebooking = true;
    });
    routePath.params.subscribe(param => {
      this.planta = param['planta'];
      this.reservationCode = param['reservation_code'];
      if (this.reservationCode != undefined && this.reservationCode != '') {
        routePath.queryParamMap.subscribe((query: any) => {
          this.token_ws = query.params.token_ws;
          if (!this.token_ws) route.navigate(['/']);
          else {
            this.confirmedPayment = true;
          }
        })
      }
    });
    gtag('event', 'FinalReserva', { 'event_category': 'FinalReserva', 'event_label': 'FinalReserva', 'value': 'FinalReserva' });
  }

  ngOnInit() {
    if (this.reservationCode != undefined && this.reservationCode != '')
      this.getBookingByReservationCode();
    else this.getBookingData();
    console.log('ngOnInit');
    if (this.token_ws != "") {
      this.bookingService.verifyWebPay(this.token_ws, this.reservationCode).subscribe({
        next: (response) => {
          if (!response.status) {
            this.route.navigate(['/booking/error'])
          } else {
            this.bookingService.updateReservation().subscribe(()=>{
            });
          }
          sessionStorage.removeItem("dataPago")
        }
      })
    }
  }
  getBookingData() {
    this.bookingService.getBookingData().subscribe(
      (response) => {
        this.date = response.selected_date;
        if (this.date === undefined) {
          this.route.navigateByUrl('/');
        } else {
          this.date = this.convertStringToFomart(response.selected_date);
          this.hour = moment(response.selected_hour, ['H:mm']).format('h:mm A');
          this.plant = response.plant;
          this.address = response.address_plant;
          this.reference = response.reference;
          this.codePlant = response.code_plant;
          this.vehicle_patent = this.patentFormat(response.vehicle_patent);
          this.latitude = response.latitude;
          this.longitude = response.longitude;
          this.tarifa = response.tarifa;
          this.typeReser = response.type_reser;
        }
      }
    );
  }
  getBookingByReservationCode() {
    this.authService.getChannel();
    this.bookingService.getByReservationCode(this.reservationCode).subscribe(
      (response) => {
        this.date = response.message.selected_date;
        if (this.date === undefined) {
          this.route.navigateByUrl('/');
        } else {
          this.date = this.convertStringToFomart(response.message.selected_date);
          this.hour = moment(response.message.selected_hour, ['H:mm']).format('h:mm A');
          this.plant = response.message.plant;
          this.address = response.message.address_plant;
          this.reference = response.message.reference;
          this.vehicle_patent = this.patentFormat(response.message.vehicle_patent);
          this.latitude = response.message.latitude;
          this.longitude = response.message.longitude;
        }
      }
    );
  }
  convertStringToFomart(dt, format = 'DD MMMM YYYY') {
    moment.locale('es-es');
    return moment.utc(dt).format(format);
  }
  home() {
    window.location.href = 'https://www.revisionestecnicas.cl/'
  }

  patentFormat(string) {
    string = string.toUpperCase();
    let sPatenteFormateado = '';
    string = this.patentWithOutFormat(string);
    string = string.substring(0, 6);
    if (string.length === 5) {
      if (this.patentMotoOld(string)) {
        string = [string.slice(0, 2),
          '-', string.slice(2)].join('');
      } else if (this.patentMotoNew(string)) {
        string = [string.slice(0, 3),
          '-', string.slice(3)].join('');
      }
    } else if (string.length === 6) {
      if (this.patentVehicleOld(string)) {
        string = [string.slice(0, 2),
          '-', string.slice(2)].join('');
      } else if (this.patentVehicleNew(string)) {
        string = [string.slice(0, 4),
          '-', string.slice(4)].join('');
      }
    }
    return string;
  }

  patentWithOutFormat(string) {
    return string.replace(/\W+/g, "").toUpperCase();
  }

  patentMotoOld(string) {
    return string.match(/^[a-z]{2}0[0-9]{3}$|^[a-z]{2}[0-9]{3}$/i)
  }

  patentMotoNew(string) {
    return string.match(/^[b-d,f-h,j-l,p,r-t,v-z]{3}[0-9]{2}$|^[b-d,f-h,j-l,p,r-t,v-z]{3}0[0-9]{2}$/i)
  }

  patentVehicleOld(string) {
    return string.match(/^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}$/i)
  }

  patentVehicleNew(string) {
    return string.match(/^[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}$/i)
  }
}
